import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// Global error handler to catch and suppress non-critical browser errors
window.addEventListener('error', (event) => {
  const message = event.error?.message || event.message || '';
  
  // Suppress known non-critical errors
  if (message.includes('ResizeObserver loop limit exceeded') ||
      message.includes('ResizeObserver loop completed with undelivered notifications') ||
      message.includes('Non-Error promise rejection captured') ||
      message.includes('Failed to fetch') ||
      message.includes('Failed fetch') ||
      message.includes('not 2xx response') ||
      message.includes('NetworkError')) {
    event.preventDefault();
    return;
  }
  
  // Log match errors for debugging but don't spam console
  if (message.includes('match')) {
    console.warn('Router match error (non-critical):', event.error?.message);
    return;
  }
});

window.addEventListener('unhandledrejection', (event) => {
  // Handle different types of promise rejections
  const reason = event.reason;
  const message = reason?.message || String(reason) || '';
  
  // Suppress API-related rejections that are handled elsewhere
  if (message.includes('Failed to fetch') ||
      message.includes('Failed fetch') ||
      message.includes('not 2xx response') ||
      message.includes('429') ||
      message.includes('Too Many Requests') ||
      message.includes('api/properties') ||
      message.includes('api/availability') ||
      message.includes('api/amenity-configurations') ||
      message.includes('api/calendar') ||
      message.includes('NetworkError') ||
      message.includes('fetch') ||
      message.includes('ResizeObserver')) {
    event.preventDefault();
    return;
  }
  
  // Handle empty objects or undefined rejections (common with network timeouts)
  if (!reason || (typeof reason === 'object' && Object.keys(reason).length === 0)) {
    console.warn('Unhandled promise rejection caught:', reason);
    event.preventDefault();
    return;
  }
  
  // Log router-related errors for debugging
  if (message.includes('match')) {
    console.warn('Router unhandled rejection (non-critical):', event.reason);
    event.preventDefault();
    return;
  }
  
  // Suppress all other unhandled promise rejections to prevent console spam
  console.warn('Unhandled promise rejection suppressed:', reason);
  event.preventDefault();
});

// Additional safeguard - catch any remaining promise rejections
Promise.prototype.catch = (function(originalCatch) {
  return function(onRejected?: ((reason: any) => any) | null | undefined) {
    return originalCatch.call(this, (reason: any) => {
      // Handle network and API errors silently
      const message = reason?.message || String(reason) || '';
      if (message.includes('Failed to fetch') ||
          message.includes('Failed fetch') ||
          message.includes('not 2xx response') ||
          message.includes('NetworkError') ||
          message.includes('api/')) {
        // Silently handle common network errors
        if (onRejected) {
          return onRejected(reason);
        }
        return Promise.reject(reason);
      }
      
      if (onRejected) {
        return onRejected(reason);
      }
      return Promise.reject(reason);
    });
  };
})(Promise.prototype.catch);

createRoot(document.getElementById("root")!).render(<App />);
